// A tiny sound on/off toggle, reused on the game screen and home. Reflects and
// flips the persisted mute state from `sound.ts`.

import { isMuted, toggleMuted } from "../sound.ts";
import { t } from "../i18n/index.ts";

export function muteButton(): HTMLButtonElement {
  const b = document.createElement("button");
  b.type = "button";
  b.className = "btn ghost icon mute";
  const paint = () => {
    const off = isMuted();
    b.textContent = off ? "🔇" : "🔊";
    b.setAttribute("aria-label", off ? t("mute.unmute") : t("mute.mute"));
    b.setAttribute("aria-pressed", String(off));
    b.title = off ? t("mute.soundOff") : t("mute.soundOn");
  };
  paint();
  b.addEventListener("click", () => {
    toggleMuted();
    paint();
  });
  return b;
}
